module.exports = __webpack_public_path__ + "community4.505d1b68.png";